import Icon from '@ant-design/icons'
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'

function ZoomGlassSvg() {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 490.8 490.8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          style={{ fill: '#FFFFFF' }}
          d="M364.8,299.55c46.3-75.8,36.9-176.3-28.6-241.9c-76.8-76.8-201.8-76.8-278.6,0s-76.8,201.8,0,278.5
          c65.5,65.5,166,74.9,241.9,28.6L412,477.25c18,18,47.3,18,65.3,0s18-47.3,0-65.3L364.8,299.55z M295.5,295.55
          c-54.4,54.4-142.8,54.4-197.1,0c-54.4-54.4-54.4-142.8,0-197.1c54.4-54.4,142.8-54.4,197.1,0
          C349.8,152.75,349.8,241.15,295.5,295.55z M220,171.95h59.4v45.3H220v59.4h-45.3v-59.4h-59.3v-45.3h59.4v-59.4h45.3v59.4H220z"
        />
      </g>
    </svg>
  )
}

function ZoomGlassMinusSvg() {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 490.8 490.8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          style={{ fill: '#FFFFFF' }}
          d="M364.8,299.5c46.3-75.8,36.9-176.3-28.6-241.9c-76.8-76.8-201.8-76.8-278.6,0s-76.8,201.8,0,278.6
          c65.5,65.5,166,74.9,241.9,28.6L412,477.3c18,18,47.3,18,65.3,0s18-47.3,0-65.3L364.8,299.5z M295.5,295.5
          c-54.4,54.4-142.8,54.4-197.1,0C44,241.1,44,152.7,98.4,98.4c54.4-54.4,142.8-54.4,197.1,0C349.8,152.7,349.8,241.1,295.5,295.5z
          M128,167.3h138.7v54.6H128V167.3z"
        />
      </g>
    </svg>
  )
}

export function ZoomGlass(props: Partial<CustomIconComponentProps>) {
  return <Icon component={ZoomGlassSvg} {...props} />
}

export function ZoomGlassMinus(props: Partial<CustomIconComponentProps>) {
  return <Icon component={ZoomGlassMinusSvg} {...props} />
}
